import { httpGet, httpPost, httpPatchMerge, httpDelete } from './../http'
import type { TEntityId } from '~/types/models'
import type { IContactRole } from '~/types/contact/models'

const apiEntityPath = '/api/tsdcontactroles'

export async function getTsdContactRoles() {
  const callingMn = getTsdContactRoles.name
  const apiPath = `${apiEntityPath}`
  return httpGet<IContactRole[]>({ callingMn, apiPath })
}

export async function createTsdContactRole(entity: IContactRole) {
  const callingMn = createTsdContactRole.name
  const apiPath = apiEntityPath
  return httpPost<IContactRole>({ callingMn, apiPath, entity })
}

export async function updateTsdContactRole(
  entityData: Partial<IContactRole>,
  id: TEntityId
) {
  const callingMn = updateTsdContactRole.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialITsdContactRole = Partial<IContactRole>
  return httpPatchMerge<TPartialITsdContactRole>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteTsdContactRole(entityData: IContactRole) {
  const callingMn = deleteTsdContactRole.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
